import classNames from 'classnames/bind';
import React from 'react';
import { FaMapMarker } from 'react-icons/fa';

import styles from './Marker.module.scss';

import { getCSSVariable } from '@/utils/theme';

const cx = classNames.bind(styles);

const Marker = ({ color = getCSSVariable('--tint-color'), data: marker }) => {
  return (
    <div className={cx('container')}>
      {marker.name && <div className={cx('name')}>{marker.name}</div>}
      <div className={cx('marker')}>
        <FaMapMarker size={40} color={color} />
        <div className={cx('label')}>{marker.label}</div>
      </div>
    </div>
  );
};

export default Marker;
